const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const HEADERS = new Set(['userid', 'user_id', 'id']);

/** The backend takes at most this many ids in one send or count. */
export const MAX_PLAYER_IDS = 10_000;

/**
 * Player ids from a pasted list or an uploaded CSV/TXT: split on commas,
 * whitespace and newlines, quotes trimmed, duplicates removed (ids are
 * lowercased), a `userId` / `user_id` / `id` header first is skipped. Anything
 * that is not a UUID is returned in `invalid`, so the form can show it
 * instead of dropping it; over 10,000 ids adds '(over 10,000 ids)'.
 */
export function parsePlayerIdList(text: string): { ids: string[]; invalid: string[] } {
  const tokens = text
    .split(/[\s,]+/)
    .map((t) => t.replace(/^["']+|["']+$/g, ''))
    .filter(Boolean);
  const ids: string[] = [];
  const invalid: string[] = [];
  const seen = new Set<string>();
  tokens.forEach((token, i) => {
    if (i === 0 && HEADERS.has(token.toLowerCase())) return;
    if (!UUID_RE.test(token)) {
      invalid.push(token);
      return;
    }
    const id = token.toLowerCase();
    if (seen.has(id)) return;
    seen.add(id);
    ids.push(id);
  });
  if (ids.length > MAX_PLAYER_IDS) invalid.push('(over 10,000 ids)');
  return { ids, invalid };
}
